/* raw layout hash: _default-web-layout-1jru55b:afa9e1fc15f586dc9415a600e9c6658507136a73c5c55645b8183c888e39ae01 */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_default-web-layout-1jru55b" (RawHTMLDesign/layouts/_default-web-layout-1jru55b.html)
export default function DefaultWebLayout1jru55b({ children }) {
  return <AppShell menuKey="full">{children}</AppShell>;
}
